import React from "react";
import Explainer from "../ExplainerModal";

const ETrackerStageInsightsExplainer = () => {
  return (
    <Explainer
      title="📊 E-Tracker Stage Insights Explainer"
      content={
        <>
          <h3 style={{ fontSize: "20px", fontWeight: "bold", marginBottom: "10px", color: "#137A08" }}>
            🌍 Overview
          </h3>
          <p>
            The E-Tracker Stage Insights page provides high-level visualizations through various charts, offering
            insights across different policy development stages. The tabs include: <strong>Overview</strong>,
            <strong> Initiation</strong>, <strong>Development</strong>, <strong>Validation</strong>, <strong>Approval</strong>,
            <strong> Legislation</strong>, <strong>Implementation</strong>, and <strong>Policy Win</strong>.
          </p>

          <h3 style={{ fontSize: "18px", fontWeight: "bold", marginTop: "15px", color: "#333" }}>
            📊 Overview Charts
          </h3>
          <ul>
            <li>🍩 <strong>Donut Charts</strong>
              <ul>
                <li>📌 <strong>Policy Distribution</strong> - Displays the distribution of policies per stage.</li>
                <li>📌 <strong>Policy Score</strong> - Shows the distribution of scores per stage.</li>
              </ul>
            </li>
            <li>🗺️ <strong>Choropleth Africa Map</strong>
              <ul>
                <li>📌 <strong>Policy Distribution</strong> - Highlights policy distribution across AGRA-focus countries.</li>
                <li>📌 <strong>Policy Score</strong> - Visualizes policy scores across AGRA-focus countries.</li>
              </ul>
            </li>
            <li>📊 <strong>Horizontal Bar Chart</strong>
              <ul>
                <li>📌 <strong>Policy Distribution</strong> - Displays the number of policies per agri-food system.</li>
                <li>📌 <strong>Policy Score</strong> - Represents policy scores per agri-food system.</li>
              </ul>
            </li>
            <li>📈 <strong>Policies Across Systems and Stages</strong>
              <ul>
                <li>📌 <strong>Policy Distribution</strong> - Vertical bar chart displaying the number of policies across six stages.</li>
                <li>📌 <strong>Policy Score</strong> - Vertical bar chart showing policy scores across six stages.</li>
              </ul>
            </li>
          </ul>

          <h3 style={{ fontSize: "18px", fontWeight: "bold", marginTop: "15px", color: "#333" }}>
            🔄 Stage-Specific Insights (Initiation to Implementation)
          </h3>
          <p>Each stage has two sections: <strong>Policy Distribution</strong> and <strong>Time Analysis</strong>.</p>
          <ul>
            <li>📌 <strong>Policy Distribution</strong>
              <ul>
                <li>🗺️ Policy distribution map displaying the number of policies across countries.</li>
                <li>📊 Horizontal bar chart illustrating policy distribution across agri-food systems.</li>
              </ul>
            </li>
            <li>⏳ <strong>Time Analysis</strong>
              <ul>
                <li>🗺️ Choropleth map indicating how long policies have remained in that stage per country.</li>
                <li>📊 Horizontal bar chart showing time spent per system in that stage.</li>
              </ul>
            </li>
          </ul>

          <h3 style={{ fontSize: "18px", fontWeight: "bold", marginTop: "15px", color: "#333" }}>
            🏆 Policy Win Insights
          </h3>
          <p>Similar to other stages, Policy Win has two sections:</p>
          <ul>
            <li>📌 <strong>Policy Distribution</strong>
              <ul>
                <li>🗺️ Map showcasing the number of policies considered policy wins across countries.</li>
                <li>📊 Horizontal bar chart displaying policy wins across agri-food systems.</li>
              </ul>
            </li>
            <li>⏳ <strong>Time Analysis</strong>
              <ul>
                <li>🗺️ Choropleth map representing time policies have spent in this stage.</li>
                <li>📊 Horizontal bar chart showing time spent per system for policies that achieved policy wins.</li>
              </ul>
            </li>
          </ul>

          <p style={{ fontSize: "14px", color: "#555", fontStyle: "italic", marginTop: "10px" }}>
            <strong>Note:</strong> A <strong>Policy Win</strong> is defined as a policy that has successfully finished all the milestones in <strong>Legislation Stage</strong> and is ready for implementation.
          </p>
        </>
      }
    />
  );
};

export default ETrackerStageInsightsExplainer;
